import React, { useEffect, useState } from "react";
import NotAuthorized from "../../components/NotAuthorized";
import { Events } from "./Events";
import "./index.scss";

const NewEvents = () => {
  const [isSchoolActive, setIsSchoolActive] = useState(false);

  let orgInfo = localStorage?.getItem("organization")
    ? JSON.parse(localStorage?.getItem("organization"))
    : [];

  let authorizedModulesInfo = localStorage?.getItem("authorizedModules")
    ? JSON.parse(localStorage?.getItem("authorizedModules"))
    : [];

  useEffect(() => {
    const status =
      orgInfo?.authorizedModules?.find(
        (item) => item?.moduleName === "events"
      )?.active === true &&
      authorizedModulesInfo?.find((item) => item?.moduleName === "events")
        ?.active === true
        ? true
        : false;

    setIsSchoolActive(status);
  }, []);

  return !isSchoolActive ? <NotAuthorized title={"Events"} /> : <Events />;
};

export default NewEvents;
